import React, { Component } from "react";
import { trans, setComoAfterThirdSymbol } from "../../../helpers/index";
import ApiManager from "../../../apiManager/index";
import Select, { components } from "react-select";
import ErrorModal from "../../Fragments/ErrorModal";

class RoamingInternational extends Component {
  constructor(props) {
    super(props);

    this.state = {
      roamingRadio: true,
      roamingCountries: "",
      roamingData: "",
      roamingSelectedOption: null,
      internationalRadio: false,
      internationalCountries: "",
      internationalData: "",
      internationalSelectedOption: null,
      loadingData: false,
      showErrorModal: false,
    };

    this.componentIsMounted = true;
    this.roamingCountriesListSuccess =
      this.roamingCountriesListSuccess.bind(this);
    this.internationalCountriesListSuccess =
      this.internationalCountriesListSuccess.bind(this);
    this.handleSelectChange = this.handleSelectChange.bind(this);
    this.roamingDataSuccess = this.roamingDataSuccess.bind(this);
    this.internationalDataSuccess = this.internationalDataSuccess.bind(this);
    this.errorCallBack = this.errorCallBack.bind(this);

  }

  componentWillUnmount() {
    this.componentIsMounted = false;
  }

  roamingCountriesListSuccess(resolve) {
    if (!this.componentIsMounted) {
      return;
    }

    this.setState(
      {
        roamingCountries: resolve.data,
      },
      this.options
    );
  }

  internationalCountriesListSuccess(resolve) {
    if (!this.componentIsMounted) {
      return;
    }

    this.setState({
      internationalCountries: resolve.data,
    });
  }

  errorCallBack(reject) {
    this.setState({ showErrorModal: true });
  }

  handleSelectChange(newState) {
    let newSelectedState = {};

    if (this.state.roamingRadio) {
      newSelectedState["roamingSelectedOption"] = newState;
    } else {
      newSelectedState["internationalSelectedOption"] = newState;
    }

    this.setState(newSelectedState, this.getDataList);
  }

  options() {
    let data = [];

    if (this.state.roamingRadio) {
      if (
        this.state.roamingCountries !== "" &&
        this.state.roamingCountries.status === "OK"
      ) {
        data = this.state.roamingCountries.data.countries.map((item) => {
          return {
            value: item.id,
            label: item.name,
            icon: <img src={item.icon} alt={item.name} />,
          };
        });
      }
    } else if (
      this.state.internationalCountries !== "" &&
      this.state.internationalCountries.status === "OK"
    ) {
      data = this.state.internationalCountries.data.countries.map((item) => {
        return {
          value: item.id,
          label: item.name,
          icon: item.icon,
        };
      });
    }

    return data;
  }

  getDataList() {
    this.setState({
      loadingData: true,
    });

    if (this.state.roamingRadio) {
      ApiManager.getRequest(
        {
          country_id: this.state.roamingSelectedOption.value,
          jwt: this.props.getDecryptedToken(),
        },
        "/roaming/list"
      ).then(this.roamingDataSuccess, this.errorCallBack);
    } else if (this.state.internationalRadio) {
      ApiManager.getRequest(
        {
          country_id: this.state.internationalSelectedOption.value,
          jwt: this.props.getDecryptedToken(),
        },
        "/international/list"
      ).then(this.internationalDataSuccess, this.errorCallBack);
    }
  }

  roamingDataSuccess(resolve) {
    if (!this.componentIsMounted) {
      return;
    }

    this.setState(
      {
        roamingData: resolve.data,
        loadingData: false,
      },
      this.options
    );
  }

  internationalDataSuccess(resolve) {
    if (!this.componentIsMounted) {
      return;
    }

    this.setState(
      {
        internationalData: resolve.data,
        loadingData: false,
      },
      this.options
    );
  }

  sectionFirst() {
    if (
      this.state.internationalRadio ||
      this.state.roamingData === "" ||
      this.state.roamingData.status !== "OK" ||
      !this.state.roamingData.data.promos.length
    ) {
      return "";
    }

    const promoList = this.state.roamingData.data.promos[0].data.map(
      (item, index) => {
        return (
          <li className="list__item" key={index}>
            <div className="list__link list__link--space-24 pr clear-fix">
              <div className="list__inner-info fs14 ver-top-box tl">
                {item.label}
              </div>
              <div className="list__inner-info list__inner-info--dark fb ver-top-box tr">
                {setComoAfterThirdSymbol(item.value)} {item.unit}
              </div>
            </div>
          </li>
        );
      }
    );

    return (
      <div className="main-wrapper__third-list-item ver-top-box">
        <section className="main-wrapper__services main-wrapper__services--yellow">
          <h2 className="main-wrapper__sub-title main-wrapper__sub-title--refresh main-wrapper__sub-title--white-bg monserrat-medium pr sprite-b">
            {this.state.roamingData.data.promos[0].title}
          </h2>

          <div className="main-wrapper__list-out">
            <ul className="list">{promoList}</ul>
          </div>
        </section>
      </div>
    );
  }

  sectionSecond() {
    let data = [];

    if (
      (this.state.roamingRadio &&
        (this.state.roamingData === "" ||
          this.state.roamingData.status !== "OK" ||
          !this.state.roamingData.data.packages.length)) ||
      (this.state.internationalRadio &&
        (this.state.internationalData === "" ||
          this.state.internationalData.status !== "OK" ||
          !this.state.internationalData.data.packages.length))
    ) {
      return "";
    } else if (this.state.roamingRadio) {
      data = this.state.roamingData.data.packages;
    } else if (this.state.internationalRadio) {
      data = this.state.internationalData.data.packages;
    }

    const packagesList = data.map((item, index) => {
      const link = (
        <div className="list__item">
          <a
            className="list__export-btn list__export-btn--gray db monserrat-medium tl pr"
            href={item.url.replace(/\?ref=mobile/, "")}
            target="_blank"
            rel="noopener noreferrer"
          >
            {item.name}
            <span className="list__next-btn ver-top-box sprite"></span>
          </a>
        </div>
      );

      let list = "";

      if (this.state.roamingRadio && item.options) {
        list = item.options.map((inItem, inIndex) => {
          return (
            <div className="list__item" key={inIndex}>
              <div className="list__link list__link--space-24 pr clear-fix">
                <div className="list__inner-info fs14 ver-top-box tl">
                  {inItem.label}
                </div>
                <div className="list__inner-info list__inner-info--dark fb ver-top-box tr">
                  {setComoAfterThirdSymbol(inItem.value)} {inItem.unit}
                </div>
              </div>
            </div>
          );
        });
      } else {
        list = (
          <div className="list__item">
            <div className="list__link list__link--space-24 pr clear-fix">
              <div className="list__inner-info--dark fs14">
                {item.description}
              </div>
            </div>
          </div>
        );
      }

      return (
        <div key={index}>
          {link}
          {list}
        </div>
      );
    });

    return (
      <div className="main-wrapper__third-list-item ver-top-box">
        <section className="main-wrapper__services">
          <h2 className="main-wrapper__sub-title main-wrapper__sub-title--services main-wrapper__sub-title--white-bg monserrat-medium pr sprite-b">
            {trans(
              this.props.trans,
              "roaming_international.special_offers_title"
            )}
          </h2>

          <div className="main-wrapper__list-out">
            <div className="list">{packagesList}</div>
          </div>
        </section>
      </div>
    );
  }

  sectionThird() {
    let data = [];

    if (
      (this.state.roamingRadio &&
        (this.state.roamingData === "" ||
          this.state.roamingData.status !== "OK" ||
          !this.state.roamingData.data.non_promo)) ||
      (this.state.internationalRadio &&
        (this.state.internationalData === "" ||
          this.state.internationalData.status !== "OK" ||
          !this.state.internationalData.data.info.length))
    ) {
      return "";
    } else if (this.state.roamingRadio) {
      data = this.state.roamingData.data.non_promo.data;
    } else if (this.state.internationalRadio) {
      data = this.state.internationalData.data.info;
    }

    const infoList = data.map((item, index) => {
      return (
        <li className="list__item" key={index}>
          <div className="list__link list__link--space-24 pr clear-fix">
            <div className="list__inner-info fs14 ver-top-box tl">
              {item.label}
            </div>
            <div className="list__inner-info list__inner-info--dark fb ver-top-box tr">
              {setComoAfterThirdSymbol(item.value)} {item.unit}
            </div>
          </div>
        </li>
      );
    });

    return (
      <div className="main-wrapper__third-list-item ver-top-box">
        <section className="main-wrapper__services">
          <h2 className="main-wrapper__sub-title main-wrapper__sub-title--services main-wrapper__sub-title--white-bg monserrat-medium pr sprite-b">
            {trans(
              this.props.trans,
              "roaming_international.basic_tariffs_title"
            )}
          </h2>

          <div className="main-wrapper__list-out">
            <ul className="list">{infoList}</ul>
          </div>
        </section>
      </div>
    );
  }

  selectMenuScrollToActiveIndex() {
    setTimeout(() => {
      let scrollBox = document.querySelector(".css-11unzgr"),
        activeElem = document.querySelector(".select-flag-option--active");

      if (scrollBox && activeElem) {
        scrollBox.scrollTop =
          activeElem.offsetTop -
          (scrollBox.offsetHeight - activeElem.offsetHeight);
      }
    }, 0);
  }

  getCountries() {
    if (this.state.roamingRadio) {
      // Get roaming countries list
      ApiManager.getRequest(
        {
          jwt: this.props.getDecryptedToken(),
        },
        "/roaming/countries"
      ).then(this.roamingCountriesListSuccess, this.errorCallBack);
    } else {
      // Get international countries list
      ApiManager.getRequest(
        {
          jwt: this.props.getDecryptedToken(),
        },
        "/international/countries"
      ).then(this.internationalCountriesListSuccess, this.errorCallBack);
    }
  }

  filterSection() {
    const Option = (props) => {
      const { innerProps, innerRef } = props;
      let img = this.state.roamingRadio ? (
        props.data.icon
      ) : (
        <img src={props.data.icon} alt={props.data.label} />
      );

      return (
        <div
          className={`select-flag-option pr${
            props.isSelected
              ? " select-flag-option--active"
              : props.isFocused
              ? " select-flag-option--focused"
              : ""
          }`}
          ref={innerRef}
          {...innerProps}
        >
          {img}
          <p className="select-flag-option__label">{props.data.label}</p>
        </div>
      );
    };

    const ValueContainer = ({ children, ...props }) => {
      const { hasValue, selectProps } = props;

      if (hasValue) {
        let img = this.state.roamingRadio ? (
          selectProps.value.icon
        ) : (
          <img src={selectProps.value.icon} alt={selectProps.value.label} />
        );

        return (
          <components.ValueContainer {...props}>
            <div
              className="select-flag-title pr no-wrap full-width"
              style={{
                display: "flex",
                alignItems: "center",
              }}
            >
              {img}
              <div
                style={{
                  marginLeft: "30px",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                {children}
              </div>
            </div>
          </components.ValueContainer>
        );
      }

      return (
        <components.ValueContainer {...props}>
          <div
            className="select-flag-title pr no-wrap full-width"
            style={{
              display: "flex",
              alignItems: "center",
            }}
          >
            {children}
          </div>
        </components.ValueContainer>
      );
    };

    let isDisabled = false;

    if (
      (this.state.roamingRadio && this.state.roamingCountries === "") ||
      (this.state.internationalRadio &&
        this.state.internationalCountries === "")
    ) {
      this.getCountries();
      isDisabled = true;
    }

    return (
      <section className="main-wrapper__services main-wrapper__services--with-space">
        <h2 className="main-wrapper__sub-title main-wrapper__sub-title--filter monserrat-medium pr sprite-b">
          {trans(this.props.trans, "roaming_international.filter.title")}
        </h2>

        <div className="main-wrapper__list-out main-wrapper__list-out--services-big">
          <ul className="list list--double list--big">
            <li className="list__item">
              <div className="list__link list__link--white-bg tc">
                <form className="filter-form" action="#" method="post">
                  <div className="filter-form__box ver-top-box">
                    <div className="filter-form__label-box tl">
                      <label
                        className="filter-form__label fs11"
                        htmlFor="filter-1"
                      >
                        {trans(
                          this.props.trans,
                          "roaming_international.filter.switcher_label"
                        )}
                      </label>
                    </div>
                    <div className="filter-form__radio-group">
                      <input
                        className="filter-form__radio dn"
                        name="filter-radio"
                        type="radio"
                        id="filter-1"
                        checked={this.state.roamingRadio}
                        onChange={() => {
                          this.setState(
                            {
                              roamingRadio: true,
                              internationalRadio: false,
                            },
                            this.options
                          );
                        }}
                      />
                      <label
                        className="filter-form__label filter-form__label--btn fs14 ver-top-box"
                        htmlFor="filter-1"
                      >
                        {trans(
                          this.props.trans,
                          "roaming_international.filter.roaming_label"
                        )}
                      </label>
                      <input
                        className="filter-form__radio dn"
                        name="filter-radio"
                        type="radio"
                        id="filter-2"
                        checked={this.state.internationalRadio}
                        onChange={() => {
                          this.setState(
                            {
                              roamingRadio: false,
                              internationalRadio: true,
                            },
                            this.options
                          );
                        }}
                      />
                      <label
                        className="filter-form__label filter-form__label--btn fs14 ver-top-box"
                        htmlFor="filter-2"
                      >
                        {trans(
                          this.props.trans,
                          "roaming_international.filter.international_label"
                        )}
                      </label>
                    </div>
                  </div>
                  <div className="filter-form__box ver-top-box">
                    <div className="filter-form__label-box tl">
                      <label
                        className="filter-form__label fs11"
                        htmlFor="filter-country"
                      >
                        {trans(
                          this.props.trans,
                          "roaming_international.filter.select_label"
                        )}
                      </label>
                    </div>
                    <div className="filter-form__select-box tl">
                      <Select
                        styles={{
                          control: () => ({
                            borderRadius: "25px",
                            display: "flex",
                            border: "1px solid #ebedef",
                          }),
                        }}
                        options={this.options()}
                        components={{ Option, ValueContainer }}
                        value={
                          this.state[
                            this.state.roamingRadio
                              ? "roamingSelectedOption"
                              : "internationalSelectedOption"
                          ]
                        }
                        onChange={this.handleSelectChange}
                        placeholder={trans(
                          this.props.trans,
                          "roaming_international.filter.select_label"
                        )}
                        noOptionsMessage={() =>
                          trans(
                            this.props.trans,
                            "roaming_international.filter.select_no_options_message"
                          )
                        }
                        onMenuOpen={this.selectMenuScrollToActiveIndex}
                        isDisabled={isDisabled}
                      />
                    </div>
                  </div>
                </form>
              </div>
            </li>
          </ul>
        </div>
      </section>
    );
  }

  emptySection() {
    if (this.state.roamingRadio) {
      if (
        this.state.roamingData === "" ||
        this.state.roamingData.status !== "OK" ||
        (this.state.roamingData.status === "OK" &&
          this.state.roamingData.data.hasOwnProperty("packages") &&
          this.state.roamingData.data.packages &&
          !this.state.roamingData.data.packages.length &&
          this.state.roamingData.data.hasOwnProperty("promos") &&
          this.state.roamingData.data.promos &&
          !this.state.roamingData.data.promos.length &&
          this.state.roamingData.data.hasOwnProperty("non_promo") &&
          this.state.roamingData.data.non_promo &&
          !this.state.roamingData.data.non_promo)
      ) {
        return (
          <p className="empty-message tc">
            {trans(this.props.trans, "empty.message")}
          </p>
        );
      }
    }

    if (this.state.internationalRadio) {
      if (
        this.state.internationalData === "" ||
        this.state.internationalData.status !== "OK" ||
        (this.state.internationalData.status === "OK" &&
          this.state.internationalData.data.hasOwnProperty("packages") &&
          this.state.internationalData.data.packages &&
          !this.state.internationalData.data.packages.length &&
          this.state.internationalData.data.hasOwnProperty("info") &&
          this.state.internationalData.data.info &&
          !this.state.internationalData.data.info.length)
      ) {
        return (
          <p className="empty-message tc">
            {trans(this.props.trans, "empty.message")}
          </p>
        );
      }
    }
  }

  errorModal() {
    if (!this.state.showErrorModal) {
      return "";
    }

    return (
      <ErrorModal
        title={trans(this.props.trans, "error.modal.title")}
        description={trans(this.props.trans, "error.modal.description")}
        action_text={trans(this.props.trans, "error.modal.action_text")}
      />
    );
  }

  render() {
    if (this.state.loadingData) {
      return (
        <>
          {this.filterSection()}
          <div className="loading-box pr">
            <div className="loading"></div>
          </div>
        </>
      );
    }

    return (
      <>
        {this.filterSection()}
        {this.emptySection()}
        <div className="main-wrapper__third-list">
          {this.sectionFirst()}
          {this.sectionSecond()}
          {this.sectionThird()}
        </div>
        {this.errorModal()}
      </>
    );
  }
}

export default RoamingInternational;
